export default function Header() {
  return (
    <div className="bg-[#231C5E] text-white px-12 py-12">
      <h2 className="text-center">Terms and Conditions</h2>
    </div>
  );
}
